export function pageCount(total: bigint, pageSize: number): bigint {
  const size = BigInt(pageSize);
  return total <= 0n ? 1n : (total + size - 1n) / size;
}
